import { createFileRoute } from "@tanstack/react-router";

import OutboxEventsPage from "@/features/dashboard/pages/outbox";
import type { OutboxStatusFilter } from "@/features/dashboard/pages/outbox";

const VALID_OUTBOX_STATUSES: OutboxStatusFilter[] = ["FAILED", "PENDING", "PUBLISHED"];

export const Route = createFileRoute("/(app)/dashboard/outbox")({
  component: () => <OutboxEventsPage />,
  validateSearch: (search: Record<string, unknown>): { status?: OutboxStatusFilter } => {
    const raw = typeof search.status === "string" ? search.status.toUpperCase() : undefined;
    return {
      status: VALID_OUTBOX_STATUSES.includes(raw as OutboxStatusFilter)
        ? (raw as OutboxStatusFilter)
        : undefined,
    };
  },
});
